import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Tag, Select, Checkbox } from "antd";
import "./modalstyles.css";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import Axios from "../../../api/Axios";
import { useSelector } from "react-redux";
import { GetCookie } from "../../../config";

const DeactivationModal = ({
  visible,
  onCancel,
  onDeactivate,
  name,
  level,
  record,
  setRecord,
  setLevel
}) => {

  //console.log(name);
  const { Option } = Select;
  const clientInfo = useSelector((state) => state.user)
  const id = clientInfo.data.organization.id;
  const [loading, setLoading] = useState(false);
  const [structureData, setStructureData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [showUser, setShowUser] = useState(true);
  const [showButton, setShowButton] = useState(true)
  const [showSwitchDiv, setShowSwitchDiv] = useState(false)


  const [selectedL1Filter, setselectedL1Filter] = useState(null);
  const [selectedL2Filter, setselectedL2Filter] = useState(null);
  const [selectedL3Filter, setselectedL3Filter] = useState(null);
  const [selectedUserData, setSelectedUserData] = useState([])
  const [L1Filters, setL1Filters] = useState([]);
  const [L2Filters, setL2Filters] = useState([]);
  const [L3Filters, setL3Filters] = useState([]);

  const LoadUser2 = async () => {
    setLoading(true);
    //console.log(record, "This is record")
    try {
      const res = await Axios.get(`/inactivedetails/${record.id}/${level}`);
      //console.log(res.data);
      setStructureData(res.data?.structure);
      setUserData(res.data?.users);
      if (res.data?.users.length === 0) {
        setShowUser(false);
      }
      setLoading(false);
    } catch (err) {
      //console.log(err);
    }
  };


  const onFinish = async () => {
    try {
      const payload = {
        "users_id": selectedUserData,
        "new": {
          "entity_id": selectedL1Filter,
          "division_id": selectedL2Filter,
          "department_id": selectedL3Filter
        }

      }
      const res = await Axios.put('/switchuser/', payload, {
        headers: {
          'X-CSRFToken': GetCookie("csrftoken")
        }
      })
      console.log(res)
      setLevel(level)
      onDeactivate(record)
    } catch (err) {
      //console.log(err)
    }
  }

  const L1Filter = async () => {
    try {
      const res = await Axios.get(`/hirarchylist/?hierarchy=Level1&find=${id}`);
      setL1Filters(res.data.structure);
      //console.log(res, "HIERARCHYLIST")
    } catch (err) {
      console.error(err);
    }
  };

  const L2Filter = async () => {
    if (selectedL1Filter) {
      //console.log("IN FILTER L2 inside if")
      try {
        const res = await Axios.get(`/hirarchylist/?hierarchy=Level2&find=${selectedL1Filter}`);
        setselectedL2Filter(res.data.structure[0].id)
        setL2Filters(res.data.structure);
        L3Filter()
      } catch (err) {
        console.error(err);
      }
    }
  };


  const filteredLevel3Values = (name, values) => {
    console.log(name, values)
    let new_vals = values
    values.map((element)=>{
      if (element.department_name === name) {
        new_vals =  values.filter(items => items.department_name !== element.department_name)
      }
    })
    
    console.log(new_vals, "these are the values to be returned")
    return new_vals

  }

  const L3Filter = async () => {
    if (selectedL2Filter) {
      try {
        const res = await Axios.get(`/hirarchylist/?hierarchy=Level3&find=${selectedL2Filter}`);
        // setselectedL3Filter(res.data.structure[0].id)
        console.log(name)
        const filteredData = filteredLevel3Values(name, res.data.structure)
        setL3Filters(filteredData);
        // setL3Filters(res.data.structure);
        setselectedL3Filter(filteredData[0].id)
        if (filteredData[0].department_name === name ) {
          console.log("Selected element is the same as the current"); 
          setShowButton(false)
        }
        else {
          setShowButton(true)
        }

      } catch (err) {
        console.error(err);
      }
    }
  };
  const handleL1Select = (value) => {
    //console.log("IN HANDLE L1 SELECT")
    setselectedL1Filter(value)
    setselectedL2Filter(null)
    setselectedL3Filter(null)
    setL2Filters([])
    setL3Filters([])
        // await fetchL2Filters()
  }

  const handleL2Select = (value) => {
    setselectedL2Filter(value)
    // await fetchL3Filters()

  }


  const handleL3Select =  (value) => {
    setselectedL3Filter(value)
    const selectedFilterName = L3Filters.find((element)=> element.id === value)
    if (selectedFilterName.department_name === name ) {
      console.log("Selected element is the same as the current"); 
      setShowButton(false)
    }
    else {
      setShowButton(true)
    }
  }

  const HierachyCheckBox = (event) => {
    //console.log(event)
    setShowSwitchDiv(event.target.checked)
  }


  useEffect(() => {
    LoadUser2();
    L1Filter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  useEffect(() => {
    //console.log("IN FILTER L2")
    L2Filter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedL1Filter]);

  useEffect(() => {
    //console.log("IN FILTER L3")
    L3Filter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedL2Filter]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      // console.log(selectedRows.map(({ pk_id }) => pk_id))
      setSelectedUserData(selectedRows.map(({ pk_id }) => pk_id))
      // userData.map(({ pk_id }) => pk_id)
    },
    onSelect: (record, selected, selectedRows) => {
      console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      //console.log(selected, selectedRows, changeRows);
      setSelectedUserData(selectedRows.map(({ pk_id }) => pk_id))
    },
  };

  const structureColumns = [
    { title: "ID", dataIndex: "id", key: "id", width: 150 },
    {
      title: "Structure Name",
      dataIndex: "name",
      key: "name",
    },
    { title: "Level", dataIndex: "level", key: "level", width: 150 },
    { title: "Manager", dataIndex: "manager", key: "manager", width: 150 },
    {
      title: "No of Users",
      dataIndex: "user_count",
      key: "user_count",
      width: 120,
    },
  ];


  const userColumns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Entities", dataIndex: "entity", key: "entity" },
    { title: "Divisions", dataIndex: "division", key: "division" },
    { title: "Departments", dataIndex: "department", key: "department" },
    { title: "Manager", dataIndex: "manager", key: "manager" },
  ];
  const OnCancelFunction = () => {
    setStructureData([]);
    setUserData([]);
    setShowUser(true);
    onCancel();
    setRecord(null);
  };
  return (
    <Modal
      title={
        <p className="modal-heading" style={{ fontSize: "16.5px" }}>
          CONFIRM &nbsp;'{name}' &nbsp;DEACTIVATION
        </p>
      }
      open={visible}
      onCancel={() => OnCancelFunction()}
      footer={[
        <Button
          key="cancel"
          onClick={() => OnCancelFunction()}
          style={{ marginTop: "5px" }}
        >
          <CloseOutlined />
          CANCEL
        </Button>,
        <Button
          key="deactivate"
          type="primary"
          onClick={() => onDeactivate(record)}
          danger
          style={{ marginTop: "5px", marginRight: "7.5px" }}
          disabled={showSwitchDiv && true}
        >
          DEACTIVATE
          <DeleteOutlined />
        </Button>,
      ]}
      width={1000}
    >
      <div>
        <p className="deactive-para">
          Deactivating <strong>{name}</strong> will lead to following users and
          structures deactivated.
        </p>
        {structureData.length > 0 && (
          <>
            <p className="deactive-para-2">
              The following Structure nodes will be deactivated :{" "}
              <Tag
                color="error"
                style={{
                  fontSize: "15.5px",
                  fontWeight: "600",
                }}
              >
                {structureData.length} Nodes
              </Tag>
            </p>
            <Table
              dataSource={structureData}
              columns={structureColumns}
              size="small"
              rowKey="id"
              bordered
              className="contacts-table"
              pagination={false}
              scroll={{
                y: 125,
                x: 700,
              }}
            />
          </>
        )}
      </div>
      {showUser && (
        <div>
          <p className="deactive-para-2">
            The following users will be deactivated :{" "}
            <Tag
              color="error"
              style={{
                fontSize: "15.5px",
                fontWeight: "600",
              }}
            >
              {userData.length} Users
            </Tag>
          </p>
          <Table
            
            rowSelection={record?.can_be_moved === true && rowSelection}
            dataSource={userData}
            columns={userColumns}
            size="small"
            rowKey="id"
            bordered
            loading={loading}
            className="contacts-table"
            pagination={false}
            scroll={{
              y: 125,
              x: 700,
            }}
          />
        </div>
      )}
      {
      record?.can_be_moved && (
          <>
          <div>
            <Checkbox onChange={HierachyCheckBox}>Would you like to move the users to another hierarchy</Checkbox>
          </div>
          <div style={showSwitchDiv ? { display: "block", width : "100%" } : { display: 'none' }}>
            <div style={{display : "flex", justifyContent : "space-evenly", alignItems : "center", height : "90px",margin : "20px"}}>
              <div>
                <span className="my-form-lables">Entity</span>
                <div>
                <Select style={{width : "200px"}} 
                onSelect={handleL1Select}
                value={selectedL1Filter}
                >
                {L1Filters?.map((l1) => (
                      <Option key={l1.id} value={l1.id}>
                        {`${l1.entity_name}`}
                      </Option>
                    ))}
                </Select>
                </div>
              </div>
              <div>
              <span className="my-form-lables">Division</span>
              <div>
              <Select style={{width : "200px"}} 
                  onSelect={handleL2Select}
                  // onBlur={getLevel2}
                  value={selectedL2Filter}
                  
                  
                  >
                     {L2Filters?.map((l2) => (
                      <Option key={l2.id} value={l2.id}>
                        {`${l2.division_name}`}
                      </Option>
                    ))}
                  </Select>
              </div>
              </div>
              <div>
              <span className="my-form-lables">Department</span>
              <div>
              <Select style={{width : "200px"}}
                 onSelect={handleL3Select}
                 value={selectedL3Filter}
                  >
                     {L3Filters?.map((l3) => (
                      <Option key={l3.id} value={l3.id}>
                        {`${l3.department_name}`}
                      </Option>
                    ))}
                  </Select>
              </div>
              </div>
              
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', margin : "25px" }}>
                {
                  selectedL3Filter && selectedUserData.length > 0 && showButton === true ? (
                <Button  danger type="primary" htmlType="submit" onClick={onFinish} >
                    MOVE USERS
                  </Button>
                  ) : (
                    <Button disabled danger type="primary" htmlType="submit" onClick={onFinish} >
                    MOVE USERS
                  </Button>
                  )
                }
                {
                showButton === true ? 
                <p style={{ fontSize: "12px", marginTop : "12px" }}>By performing this action <strong>{name}</strong> will be deactivated</p>
                  
                 :  
                 <p style={{ fontSize: "12px", marginTop : "12px", color: "red"}}>Users cannot be moved to the same department</p>
                 
                 }
                </div>
          </div>
          </>
        )
      }

    </Modal>
  );
};

export default DeactivationModal;
